import AppSettingsTemplate from './appSettings.template';

const productionAppSettings: AppSettingsTemplate = {
  version: 'v1.3',
  auth0: {
    domain: 'stingray.eu.auth0.com',
    clientId: 'yojseljcFrmnjulhIQolRZpbsioQd6Cg',
    audience: 'https://stingrayapis.skywater.io/',
    scope: `openid profile Read:EquipmentPlacementFleet
             ReadWrite:NavigatorCommands
             Read:NavigatorPositions
             Read:NodesVideoStreams
             Read:NodesDataStreams
             Read:NavigatorCommands
             ReadWrite:NavigatorSchedules
             ReadWrite:NavigatorThrusters`,
  },
  apis: {
    mobileapi: {
      url: 'https://navigator.stingrayapps.no/api/v1/',
    },
    authService: {
      url: 'https://navigator.stingrayapps.no/api/v1/authservice',
    },
    streamservice: { url: 'https://stream-service-subscribers.skywater.io/hubs/subscriber' },
  },
};

export default productionAppSettings;
